import { Grid } from '@zappyrent/hundop';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  StyledDescriptionText,
  StyledNumber,
  StyledNumberListContainer,
  StyledNumberSetContainer,
  StyledNumberSetContainerLink,
} from './ZappyrentNumbers.styles';

const ZappyrentNumbers = (): JSX.Element => {
  const { t } = useTranslation('product');

  return (
    <Grid container>
      <StyledNumberListContainer>
        <StyledNumberSetContainer>
          <StyledNumber>2,5K</StyledNumber>
          <StyledDescriptionText>
            <Trans
              i18nKey="zappyrentNumbers1"
              t={t}
              components={{ break: <br /> }}
            />
          </StyledDescriptionText>
        </StyledNumberSetContainer>
        <StyledNumberSetContainer>
          <StyledNumber>50</StyledNumber>
          <StyledDescriptionText>
            <Trans
              i18nKey="zappyrentNumbers2"
              t={t}
              components={{ break: <br /> }}
            />
          </StyledDescriptionText>
        </StyledNumberSetContainer>
        <StyledNumberSetContainer>
          <StyledNumberSetContainerLink to="/it/pubblica-annuncio-gratis">
            <StyledNumber>400+</StyledNumber>
            <StyledDescriptionText>
              <Trans i18nKey="zappyrentNumbers3" t={t} />
            </StyledDescriptionText>
          </StyledNumberSetContainerLink>
        </StyledNumberSetContainer>

        <StyledNumberSetContainer>
          <StyledNumber>2h</StyledNumber>
          <StyledDescriptionText>
            <Trans
              i18nKey="zappyrentNumbers4"
              t={t}
              components={{ break: <br /> }}
            />
          </StyledDescriptionText>
        </StyledNumberSetContainer>
      </StyledNumberListContainer>
    </Grid>
  );
};

export default ZappyrentNumbers;
